import type { StoryMediaPlatform } from 'types/story';
import { EventEmitter } from 'utils/event-emitter';

type EditorKeyboardToggleLayersEvent = { type: 'toggleLayers' };
type EditorKeyboardAddCompEvent = { type: 'toggleAddComponent' };
type EditorKeyboardTogglePreviewEvent = { type: 'togglePreview' };
export type EditorKeyboardSetPlatformEvent = { type: 'setPlatform'; data: StoryMediaPlatform };

export const EditorKeyboardEvEm = new EventEmitter<
	| EditorKeyboardToggleLayersEvent
	| EditorKeyboardAddCompEvent
	| EditorKeyboardTogglePreviewEvent
	| EditorKeyboardSetPlatformEvent
>();

export const STORY_EDITOR_IFRAME_KEYDOWN_EVENT = 'story-editor:iframe-keydown';

export const forwardStoryEditorIframeKeydown = (event: KeyboardEvent) => {
	window.dispatchEvent(new CustomEvent(STORY_EDITOR_IFRAME_KEYDOWN_EVENT, { detail: event }));
};
